import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../services/ApiService'
import { showAlert } from '../../utility/SweetAlert'

const InteractorCompanyMediaDelete = () => {
  const { t } = useTranslation()
  const companyMediaDelete = useCallback(
    (uid, payload) => {
      ApiService.jsonRequest('/account-company/media-delete', payload, response => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t('message.successfully_deleted'),
            timer: 1500,
            redirect: `/company/update?uid=${uid}`,
          })
        }
      })
    },
    [t],
  )
  return { companyMediaDelete }
}

export default InteractorCompanyMediaDelete
